import { Controller } from "stimulus";
import PixService from "../entrypoints/src/admin/services/pix-service";
import AjaxLoader from "../entrypoints/src/admin/utilities/ajax-loader";
import sweet_alert from "../entrypoints/src/admin/utilities/sweet_alert";

export default class extends Controller {
  connect() {
    this.element.addEventListener('change', (ev) => {
      this.updateDefaultPixKey();
    });
  }

  async updateDefaultPixKey() {
    try {
      AjaxLoader.show();
      let response = await PixService.default(this.element.selectedOptions[0].dataset.value);
      AjaxLoader.hide();

      !!response.errors && this.unprocessableEntityMessage();
    } catch(ex) {
      this.unprocessableEntityMessage();
    }
  }

  unprocessableEntityMessage() {
    AjaxLoader.hide();
    sweet_alert.fire({
      icon: 'warning',
      html: `Infelizmente não foi possível atualizar o pix padrão.`,
      showClass: { backdrop: 'swal2-noanimation', popup: '', },
      hideClass: { popup: '' },
      customClass: {
        cancelButton: 'btn btn-gray-primary',
        confirmButton: 'btn btn-primary mr-3'
      },
      buttonsStyling: false,
      showCancelButton: false
    });
  }
};